import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrFuelTruckAddPage } from './klmr-fuel-truck-add';

@NgModule({
  declarations: [
    KlmrFuelTruckAddPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrFuelTruckAddPage),
  ],
})
export class KlmrFuelTruckAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-fuel-truck-add/klmr-fuel-truck-add.module.ts